<template>
    <div class="form-group col-12 radio-container timeline">
        <!-- Radio -->
        <input type="checkbox" id="time-checkbox" v-model="showTimeline" @change="toggleTimeline" />
        <label for="time-checkbox">{{ $t('Set custom time') }}</label>
        <!-- Text -->
        <div class="input-container" v-if="showTimeline">
            <input type="range" name="timeline" id="timeline" @change="changeTimeRange" />
            <input type="text" name="actualTime" id="actualTime" :placeholder="defaultActualTime"
                v-model="product.attributes.actualTime" @change="changeTimeTextInput" />
            <input type="text" name="endTime" id="endTime" :placeholder="defaultEndTime"
                v-model="product.attributes.endTime" @change="changeTimeTextInput" />
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import useMusic from '../../useMusic'

export default {
    computed: {
        ...mapGetters({
            product: 'product/getProduct',
            range: 'product/getRange',
            showTimeline: 'product/getShowTimeline',
        })
    },
    setup() {
        const {
            defaultActualTime,
            defaultEndTime,
            changeTimeRange,
            toggleTimeline,
            changeTimeTextInput,
        } = useMusic()

        return {
            defaultActualTime,
            defaultEndTime,
            changeTimeRange,
            toggleTimeline,
            changeTimeTextInput,
        }
    }
}
</script>